'use strict';

const ajax = require('superagent');
const events = require('dom-events');

const utils = require('../utils.js');

const Comment = require('./comment.js');
const CommentStats = require('./comment-stats.js');

function CommentList (source, url, apiKey) {
  this.cls = {
    invisible: 'invisible'
  };

  this.tpl = {
    list: '[data-template="community-comments"]',
    items: '[data-template="community-comments-items"]'
  };

  this.refs = {
    root: '[data-ref="community"]',
    stats: '[data-ref="community-stats"]',
    list: '[data-ref="community-comments"]',
    items: '[data-ref="community-comments-items"]',
    replyButtons: '.comment__reply'
  };

  this.url = url + '?source=' + encodeURI(source);
  this.apiKey = apiKey;

  this.comments = {};
  this.commentCount = 0;
  this.html;
}

CommentList.prototype.buildHTML = function () {
  var html = document.querySelector(this.tpl.list).cloneNode(true);
  html.setAttribute('data-ref', html.getAttribute('data-template'));
  html.removeAttribute('data-template');

  var items = html.querySelector(this.tpl.items);
  items.setAttribute('data-ref', items.getAttribute('data-template'));
  items.removeAttribute('data-template');

  return html;
};

CommentList.prototype.getHTML = function () {
  if (!this.html) this.html = this.buildHTML();
  return this.html;
};

CommentList.prototype.setComment = function (key, data) {
  var comment = new Comment(data);
  comment.bindEvents();
  this.comments[key] = comment;
};

CommentList.prototype.getComment = function (key) {
  return this.comments[key];
};

CommentList.prototype.appendCommentStats = function (stats) {
  var commentStats = new CommentStats(stats);
  var stats = document.querySelector(this.refs.stats);
  stats.innerHTML = '';
  stats.appendChild(commentStats.getHTML());
};

CommentList.prototype.appendComment = function (data) {
  var key = data.Source + ' ' + data.CreatedAt;
  this.setComment(key, data);
  var items = this.getHTML().querySelector(this.refs.items);
  return items.appendChild(this.getComment(key).getHTML());
};

CommentList.prototype.appendComments = function () {
  var root = document.querySelector(this.refs.root);
  if (!root.querySelector(this.refs.list)) {
    root.appendChild(this.getHTML());
  }
};

CommentList.prototype.onPostComment = function (event) {
  var comment = event.data;
  if (comment) {
    this.commentCount += 1;
    this.appendCommentStats(this.commentCount.toString());
    var commentHTML;
    if (comment.hasOwnProperty('ReplyTo')) {
      commentHTML = this.getComment(comment.ReplyTo).appendReply(comment);
      events.emit(document, 'doneReply', { bubbles: true });
    } else {
      commentHTML = this.appendComment(comment);
    }
    this.appendComments();
    window.scrollTo(0, commentHTML.offsetTop);
  }
};

CommentList.prototype.onPrepareReply = function (event) {
  var replyButtons = document.querySelectorAll(this.refs.replyButtons);
  var replyButton;
  for (var i = 0; i < replyButtons.length; i++) {
    replyButton = replyButtons[i];
    replyButton.className = replyButton.className.
      replace(' ' + this.cls.invisible, '');
  }

  replyButton = event.replyButton;
  if (replyButton) {
    if (!replyButton.className.includes(this.cls.invisible)) {
      replyButton.className = replyButton.className
        .concat(' ' + this.cls.invisible);
    }
  }
};

CommentList.prototype.onCancelReply = function (event) {
  var replyButtons = document.querySelectorAll(this.refs.replyButtons);
  var replyButton;
  for (var i = 0; i < replyButtons.length; i++) {
    replyButton = replyButtons[i];
    replyButton.className = replyButton.className.
      replace(' ' + this.cls.invisible, '');
  }
};

CommentList.prototype.onDoneReply = function (event) {
  var replyButtons = document.querySelectorAll(this.refs.replyButtons);
  var replyButton;
  for (var i = 0; i < replyButtons.length; i++) {
    replyButton = replyButtons[i];
    replyButton.className = replyButton.className.
      replace(' ' + this.cls.invisible, '');
  }
};

CommentList.prototype.onBindEvents = function (event) {
  var root = utils.findTarget(this.refs.root, event);
  if (root) {
    var _this = this;
    ajax.get(this.url)
      .set({ 'x-api-key': this.apiKey })
      .then(function (response) {
        var commentData = response.body.data.Items;
        if (commentData.length > 0) {
          _this.commentCount = commentData.length;
          _this.appendCommentStats(_this.commentCount.toString());
          for (var i = 0; i < commentData.length; i++) {
            var commentItem = commentData[i];
            if (commentItem.hasOwnProperty('ReplyTo')) {
              _this.getComment(commentItem.ReplyTo).appendReply(commentItem);
            } else {
              _this.appendComment(commentItem);
            }
          }
          _this.appendComments()
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }
};

CommentList.prototype.bindEvents = function () {
  this.onPostComment = this.onPostComment.bind(this);
  events.on(document, 'postComment', this.onPostComment);

  this.onPrepareReply = this.onPrepareReply.bind(this);
  events.on(document, 'prepareReply', this.onPrepareReply);

  this.onCancelReply = this.onCancelReply.bind(this);
  events.on(document, 'cancelReply', this.onCancelReply);

  this.onDoneReply = this.onDoneReply.bind(this);
  events.on(document, 'doneReply', this.onDoneReply);

  var root = document.querySelector(this.refs.root);
  this.onBindEvents = this.onBindEvents.bind(this);
  events.on(root, 'bindEvents', this.onBindEvents);
  events.emit(root, 'bindEvents');
};

module.exports = CommentList;



//////////////////
// WEBPACK FOOTER
// ./_js/comments/comment-list.js
// module id = 30
// module chunks = 0